import { Component, OnInit } from "@angular/core";
import { DaoService } from "src/app/services/dao.service";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { LstorageService } from "src/app/services/lstorage.service";
import { Router } from "@angular/router";
import * as jwtDecode from "jwt-decode";
import { SpinnerService } from "src/app/shared/spinner/spinner.service";
import { SpinnerComponent } from "src/app/shared/spinner/spinner.component";
import { ToastService } from "src/app/services/toast.service";
import { MatPaginator } from "@angular/material/paginator";
import { MatDialogRef } from "@angular/material/dialog";
import { encryptData } from "src/app/services/aes.service";

@Component({
  selector: "app-entityform",
  templateUrl: "./entityform.component.html",
  styleUrls: ["./entityform.component.scss"],
})
export class EntityformComponent implements OnInit {
  entity: any;
  entityList: any;
  dataSource: any;
  private paginator: MatPaginator;
  public entityEdit = {
    edit: false,
  };
  created_By: any;
  modified_By: any;
  requiredEntity: any;
  public validator = {
    errorMessage: "",
    UniqueEntity: false,
  };
  public shown = {
    grid: true,
    Form: false,
  };

  Entity = new FormGroup({
    entityId: new FormControl(),
    name: new FormControl(),
    description: new FormControl(),
    isActive: new FormControl(),
    createdBy: new FormControl(),
    createdOn: new FormControl(),
    modifiedBy: new FormControl(),
    modifiedOn: new FormControl(),
  });

  constructor(
    private router: Router,
    private daoService: DaoService,
    private fb: FormBuilder,
    private token: LstorageService,
    public dialogRef: MatDialogRef<EntityformComponent>,
    private spinner: SpinnerService,
    private toast: ToastService
  ) {
    this.daoService.getEntities().subscribe((data: any) => {
      this.entity = data;
    });
  }

  ngOnInit() {
    this.created_By = jwtDecode(this.token.getToken());
    this.Entity = this.fb.group({
      entityId: [""],
      name: ["", [Validators.required]],
      description: [""],
      isActive: ["true"],
      createdBy: [this.created_By.unique_name],
      createdOn: ["2020-01-18T18:20:07.433Z"],
      modifiedBy: [""],
      modifiedOn: ["2020-01-18T18:20:07.433Z"],
    });
    (error) => {
      console.log("Error:" + error);
    };
  }
  EntityForm() {
    this.entityEdit.edit = false;
    this.shown.grid = false;
    this.shown.Form = true;
    this.Entity = this.fb.group({
      entityId: [""],
      name: ["", [Validators.required]],
      description: [""],
      isActive: ["true"],
      createdBy: [this.created_By.unique_name],
      createdOn: ["2020-01-18T18:20:07.433Z"],
      modifiedBy: [""],
      modifiedOn: ["2020-01-18T18:20:07.433Z"],
    });
  }

  createEntity() {
    this.spinner.show();
    this.validator.UniqueEntity = false;
    this.Entity.value.name = this.Entity.value.name.trim();

    if (this.Entity.value.entityId) {
      this.daoService
        .AddEntity(encryptData(JSON.stringify(this.Entity.value)))
        .subscribe(
          (data: any) => {
            if (data.isSuccess) {
              this.toast.openSnackBar("Entity updated successfully", "close");
              this.spinner.hide();
              this.entity = data.data.entityId;
              this.dialogRef.close();
            }
          },
          (error) => {
            this.spinner.hide();
            this.validator.UniqueEntity = true;
            this.validator.errorMessage = error.error.userMessage;
          }
        );
    } else {
      var ename = this.Entity.value.name;
      if (!(ename && !ename.trim())) {
        var data1 = {
          Name: ename,
        };
        this.daoService.AddEntity(encryptData(JSON.stringify(data1))).subscribe(
          (data: any) => {
            console.log("Entity added successfully");

            if (data.isOk) {
              console.log("Entity data", data);
              console.log("Entity added successfully");
              this.toast.openSnackBar("Entity added successfully", "close");
              this.spinner.hide();
              this.dialogRef.close();
            }
            this.spinner.hide();
            this.dialogRef.close();
          },
          (error) => {
            this.spinner.hide();
            this.validator.UniqueEntity = true;
            this.validator.errorMessage = error.error.userMessage;
          }
        );
      }
      this.spinner.hide();
    }
  }
  closeEntityForm() {
    this.dialogRef.close();
  }

  handleInput(event) {
    if (event.which === 32 && !this.Entity.value.name.length)
      event.preventDefault();
  }
}
